<template>
  <header
    :class="[
      'header-area bg-white text-center text-md-start pt-15 pb-15 ps-15 pe-15 ps-md-20 pe-md-20 pe-lg-30 transition mb-25 position-fixed',
      { sticky: isSticky },
    ]"
    id="header"
  >
    <div class="row align-items-center">
      <div class="col-xl-4 col-lg-5 col-md-6">
        <div
          class="header-left-side justify-content-center justify-content-md-start d-flex align-items-center"
        >
          <button
            class="header-burger-menu transition position-relative lh-1 bg-transparent p-0 border-0"
            id="header-burger-menu"
            @click="stateStoreInstance.onChange"
          >
            <i class="flaticon-menu-3"></i>
          </button>
          <div class="search-box position-relative" ref="searchBoxRef">
            <div class="input-group">
              <input
                type="text"
                class="form-control shadow-none rounded-0 border-0"
                placeholder="Rechercher une page..."
                v-model="searchQuery"
                @focus="searchOpen = true"
                @keydown.escape="closeSearch"
                @keydown.enter="goToFirst"
                @keydown.down.prevent="highlightNext"
                @keydown.up.prevent="highlightPrev"
                autocomplete="off"
              />
              <button
                class="default-btn position-relative transition border-0 fw-medium text-white pt-8 pb-8 ps-15 pe-15 pt-md-12 pb-md-12 ps-md-20 pe-md-20"
                type="button"
                @click="goToFirst"
              >
                <i class="flaticon-search-interface-symbol"></i>
              </button>
            </div>

            <!-- Dropdown results -->
            <div
              v-if="searchOpen && searchQuery.trim() && filteredPages.length"
              class="search-dropdown"
            >
              <div
                v-for="(page, i) in filteredPages"
                :key="page.path"
                class="search-result-item"
                :class="{ 'search-result-item--active': i === highlightIndex }"
                @mousedown.prevent="navigateTo(page.path)"
              >
                <i :class="page.icon" class="search-result-icon"></i>
                <span>{{ page.name }}</span>
              </div>
            </div>

            <div
              v-if="searchOpen && searchQuery.trim() && !filteredPages.length"
              class="search-dropdown"
            >
              <div class="search-no-result">Aucun résultat trouvé</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-8 col-lg-7 col-md-6">
        <div
          class="header-right-side d-flex align-items-center justify-content-center justify-content-md-end"
        >
          <!-- <div class="dropdown language-dropdown">
            <button
              class="dropdown-toggle fw-medium position-relative pt-0 pb-0 bg-transparent border-0 transition lh-1"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="flaticon-translate"></i>
              ENG
            </button>
            <div
              class="dropdown-menu rounded-0 bg-white border-0 start-auto end-0"
            >
              <div
                class="title d-flex align-items-center justify-content-between"
              >
                <span class="text-black fw-bold">Choose Language</span>
              </div>
              <ul class="ps-0 mb-0 list-unstyled dropdown-body">
                <li class="position-relative fw-semibold text-black-emphasis">
                  <img
                    src="../../assets/images/flag/usa.png"
                    width="30"
                    height="30"
                    class="rounded-circle position-absolute"
                    alt="flag"
                  />
                  English
                  <a
                    href="#"
                    class="d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  ></a>
                </li>
                <li class="position-relative fw-semibold text-black-emphasis">
                  <img
                    src="../../assets/images/flag/australia.png"
                    width="30"
                    height="30"
                    class="rounded-circle position-absolute"
                    alt="flag"
                  />
                  Australian
                  <a
                    href="#"
                    class="d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  ></a>
                </li>
                <li class="position-relative fw-semibold text-black-emphasis">
                  <img
                    src="../../assets/images/flag/spain.png"
                    width="30"
                    height="30"
                    class="rounded-circle position-absolute"
                    alt="flag"
                  />
                  Spanish
                  <a
                    href="#"
                    class="d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  ></a>
                </li>
                <li class="position-relative fw-semibold text-black-emphasis">
                  <img
                    src="../../assets/images/flag/france.png"
                    width="30"
                    height="30"
                    class="rounded-circle position-absolute"
                    alt="flag"
                  />
                  French
                  <a
                    href="#"
                    class="d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  ></a>
                </li>
                <li class="position-relative fw-semibold text-black-emphasis">
                  <img
                    src="../../assets/images/flag/germany.png"
                    width="30"
                    height="30"
                    class="rounded-circle position-absolute"
                    alt="flag"
                  />
                  German
                  <a
                    href="#"
                    class="d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  ></a>
                </li>
              </ul>
            </div>
          </div> -->
          <LightDarkSwtichBtn />
          <!-- <div class="dropdown apps-dropdown">
            <button
              class="dropdown-toggle p-0 position-relative bg-transparent border-0 transition lh-1"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="flaticon-dashboard"></i>
            </button>
            <div
              class="dropdown-menu pb-0 rounded-0 bg-white border-0 start-auto end-0"
            >
              <div
                class="title d-flex align-items-center justify-content-between"
              >
                <span class="text-black fw-bold">Apps & Social</span>
              </div>
              <ul class="ps-0 mb-0 list-unstyled dropdown-body">
                <li class="position-relative fw-semibold text-black-emphasis">
                  <div
                    class="icon rounded-circle position-absolute text-center"
                  >
                    <img
                      src="../../assets/images/icon/github.png"
                      alt="github"
                    />
                  </div>
                  GitHub
                  <a
                    href="https://github.com/"
                    target="_blank"
                    class="d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  ></a>
                </li>
                <li class="position-relative fw-semibold text-black-emphasis">
                  <div
                    class="icon rounded-circle position-absolute text-center"
                  >
                    <img
                      src="../../assets/images/icon/dribbble.png"
                      alt="dribbble"
                    />
                  </div>
                  Dribbble
                  <a
                    href="https://dribbble.com/"
                    target="_blank"
                    class="d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  ></a>
                </li>
                <li class="position-relative fw-semibold text-black-emphasis">
                  <div
                    class="icon rounded-circle position-absolute text-center"
                  >
                    <img src="../../assets/images/icon/slack.png" alt="slack" />
                  </div>
                  Slack
                  <a
                    href="https://slack.com/"
                    target="_blank"
                    class="d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  ></a>
                </li>
                <li class="position-relative fw-semibold text-black-emphasis">
                  <div
                    class="icon rounded-circle position-absolute text-center"
                  >
                    <img
                      src="../../assets/images/icon/dropbox.png"
                      alt="dropbox"
                    />
                  </div>
                  Dropbox
                  <a
                    href="https://www.dropbox.com/"
                    target="_blank"
                    class="d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  ></a>
                </li>
                <li class="position-relative fw-semibold text-black-emphasis">
                  <div
                    class="icon rounded-circle position-absolute text-center"
                  >
                    <img
                      src="../../assets/images/icon/google.png"
                      alt="google"
                    />
                  </div>
                  G. Suite
                  <a
                    href="https://workspace.google.com/"
                    target="_blank"
                    class="d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  ></a>
                </li>
              </ul>
            </div>
          </div> -->
          <!-- <div class="dropdown email-dropdown">
            <button
              class="dropdown-toggle p-0 position-relative bg-transparent border-0 transition lh-1"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="flaticon-email-2"></i>
              <span
                class="dot-badge position-absolute fw-bold rounded-circle text-white bg-success d-inline-block"
                >1</span
              >
            </button>
            <div
              class="dropdown-menu rounded-0 bg-white border-0 start-auto end-0"
            >
              <div
                class="title d-flex align-items-center justify-content-between"
              >
                <span class="text-black fw-bold"
                  >Messages <span class="text-muted">(03)</span></span
                >
                <router-link
                  to="/chat"
                  class="text-decoration-none link-btn transition fw-medium text-primary"
                  >Mark all As Read</router-link
                >
              </div>
              <ul class="ps-0 mb-0 list-unstyled dropdown-body">
                <li class="position-relative">
                  <img
                    src="../../assets/images/user/user1.jpg"
                    width="45"
                    height="45"
                    class="rounded-circle position-absolute"
                    alt="user"
                  />
                  <span class="d-block fw-semibold text-black-emphasis"
                    >Jacob Linowiski
                    <span class="ms-5 text-muted fw-normal"
                      >35 mins ago</span
                    ></span
                  >
                  Hey Victor! Could you please...
                  <router-link
                    to="/chat"
                    class="d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  ></router-link>
                  <span
                    class="unread d-inline-block rounded-circle bg-primary position-absolute w-10 h-10"
                  ></span>
                </li>
                <li class="text-muted position-relative">
                  <img
                    src="../../assets/images/user/user2.jpg"
                    width="45"
                    height="45"
                    class="rounded-circle position-absolute"
                    alt="user"
                  />
                  <span class="d-block fw-semibold text-black-emphasis"
                    >Angela Carter
                    <span class="ms-5 text-muted fw-normal"
                      >1 day ago</span
                    ></span
                  >
                  How are you Victor? Would you please...
                  <router-link
                    to="/chat"
                    class="d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  ></router-link>
                </li>
                <li class="text-muted position-relative">
                  <img
                    src="../../assets/images/user/user3.jpg"
                    width="45"
                    height="45"
                    class="rounded-circle position-absolute"
                    alt="user"
                  />
                  <span class="d-block fw-semibold text-black-emphasis"
                    >Brad Traversy
                    <span class="ms-5 text-muted fw-normal"
                      >2 days ago</span
                    ></span
                  >
                  Hey Victor! Could you please...
                  <router-link
                    to="/chat"
                    class="d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  ></router-link>
                </li>
              </ul>
              <div class="text-center dropdown-footer">
                <router-link
                  to="/chat"
                  class="link-btn text-decoration-none position-relative d-inline-block transition fw-medium fw-medium text-primary"
                >
                  View All Messages
                </router-link>
              </div>
            </div>
          </div> -->
          <div class="dropdown notification-dropdown">
            <button
              class="dropdown-toggle p-0 position-relative bg-transparent border-0 transition lh-1"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="flaticon-bell-2"></i>
              <span
                class="dot-badge position-absolute fw-bold rounded-circle text-white bg-primary d-inline-block"
              >
                0
              </span>
            </button>
            <div
              class="dropdown-menu rounded-0 bg-white border-0 start-auto end-0"
            >
              <div
                class="title d-flex align-items-center justify-content-between"
              >
                <span class="text-black fw-bold"
                  >Notifications <span class="text-muted">(00)</span></span
                >
                <!-- <router-link
                  to="/notifications"
                  class="text-decoration-none link-btn transition text-primary fw-medium"
                >
                  Clear All
                </router-link> -->
              </div>
              <ul class="ps-0 mb-0 list-unstyled dropdown-body">
                <!-- <li class="text-muted position-relative">
                  <div
                    class="icon rounded-circle position-absolute text-center"
                  >
                    <i class="ph-bold ph-chat-centered-dots"></i>
                  </div>
                  <span class="d-block text-black-emphasis"
                    >You have requested to
                    <strong class="fw-semibold">withdrawal</strong></span
                  >
                  2 hrs ago
                  <router-link
                    to="/notifications"
                    class="d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  ></router-link>
                  <span
                    class="unread d-inline-block rounded-circle bg-primary position-absolute w-10 h-10"
                  ></span>
                </li>
                <li class="text-muted position-relative">
                  <div
                    class="icon rounded-circle position-absolute text-center"
                  >
                    <i class="ph-bold ph-user-plus"></i>
                  </div>
                  <span class="d-block text-black-emphasis">
                    <strong class="fw-semibold">A new user</strong> added in
                    Adlash
                  </span>
                  3 hrs ago
                  <router-link
                    to="/notifications"
                    class="d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  ></router-link>
                  <span
                    class="unread d-inline-block rounded-circle bg-primary position-absolute w-10 h-10"
                  ></span>
                </li>
                <li class="text-muted position-relative">
                  <div
                    class="icon rounded-circle position-absolute text-center"
                  >
                    <i class="ph-bold ph-chat-centered-dots"></i>
                  </div>
                  <span class="d-block text-black-emphasis">
                    You have requested to
                    <strong class="fw-semibold">withdrawal</strong>
                  </span>
                  1 day ago
                  <router-link
                    to="/notifications"
                    class="d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  ></router-link>
                </li> -->
              </ul>
              <!-- <div class="text-center dropdown-footer">
                <router-link
                  to="/notifications"
                  class="link-btn text-decoration-none text-primary position-relative d-inline-block transition fw-medium fw-medium"
                >
                  See All Notifications
                </router-link>
              </div> -->
            </div>
          </div>
          <div class="dropdown profile-dropdown">
            <button
              class="dropdown-toggle text-start fs-14 text-black-emphasis d-flex align-items-center p-0 position-relative bg-transparent border-0 transition lh-1"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <img
              v-if="user?.pic"
                :src="user.pic"
                class="rounded"
                width="44"
                height="44"
                alt="admin"
              />
             
               <img
                v-else
                :src="require('@/assets/images/NoImage.png')"
                class="rounded"
                width="44"
                height="44"
                alt="admin" />
              <span class="title d-none d-lg-block ms-10 ms-lg-15">
                <span class="d-block fw-bold mb-5 mb-md-8">{{
                  user?.name
                }}</span>
                <span class="text-body-emphasis fw-semibold fs-13">Admin</span>
              </span>
            </button>
            <div
              class="dropdown-menu rounded-0 bg-white border-0 start-auto end-0"
            >
              <ul class="ps-0 mb-0 list-unstyled dropdown-body">
                <li
                  class="text-body-secondary fw-semibold transition position-relative"
                >
                  <i class="flaticon-user-2"></i>
                  Mon compte
                  <router-link
                    to="/profile"
                    class="d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  ></router-link>
                </li>
                <li
                  class="text-body-secondary fw-semibold transition position-relative"
                >
                  <i class="flaticon-setting"></i>
                  Paramètres
                  <router-link
                    to="/account-settings"
                    class="d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  ></router-link>
                </li>
                <!-- <li
                  class="text-body-secondary fw-semibold transition position-relative"
                >
                  <i class="flaticon-warning"></i>
                  Support
                  <router-link
                    to="/support-desk-card"
                    class="d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  ></router-link>
                </li> -->
                <li
                  class="text-body-secondary fw-semibold transition position-relative"
                >
                  <i class="flaticon-logout"></i>
                  <button
                    @click="handleLogout()"
                    class="btn border-0 bg-transparent p-0 fw-semibold text-body-secondary w-100 text-start"
                  >
                    Déconnexion
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import LightDarkSwtichBtn from "./LightDarkSwtichBtn.vue";
import stateStore from "../../utils/store";
import { useAuthStore } from "@/stores/auth";

const ALL_PAGES = [
  { name: "Tableau de bord", path: "/", icon: "flaticon-home" },
  { name: "Liste des colis", path: "/colis-list", icon: "flaticon-sterile-box" },
  { name: "Nouveau colis", path: "/add-colis", icon: "flaticon-add" },
  { name: "Nouveaux colis", path: "/new-colis-list", icon: "flaticon-sterile-box" },
  { name: "Liste des clients", path: "/customers-list", icon: "flaticon-users-group" },
  { name: "Ajouter client", path: "/add-customer", icon: "flaticon-add" },
  { name: "Nouveaux clients", path: "/new-customers-list", icon: "flaticon-users-group" },
  { name: "Liste des utilisateurs", path: "/users-list", icon: "flaticon-user-2" },
  { name: "Ajouter utilisateur", path: "/add-user", icon: "flaticon-add" },
  { name: "Livreurs en attente", path: "/new-driver-list", icon: "flaticon-fast-delivery" },
  { name: "Réclamations", path: "/claims-list", icon: "flaticon-information" },
  { name: "Ramassages", path: "/pickup-list", icon: "flaticon-cube-3d" },
  { name: "Demandes ramassage", path: "/requests-pickup-list", icon: "flaticon-cube-3d" },
  { name: "Bons de livraison", path: "/delivery-notes", icon: "flaticon-document" },
  { name: "Bons de livraison stock", path: "/delivery-stock-notes", icon: "flaticon-document" },
  { name: "Bons de réception", path: "/reception-notes", icon: "flaticon-draft" },
  { name: "Bons d'envoi", path: "/sent-notes", icon: "flaticon-telegram" },
  { name: "Bons de distribution", path: "/distribution-notes", icon: "flaticon-notes" },
  { name: "Bons de paiement livreur", path: "/payment-note-liste", icon: "flaticon-money" },
  { name: "Bons de paiement zone", path: "/payment-zone-liste", icon: "flaticon-money" },
  { name: "Retours clients", path: "/return-client-liste", icon: "flaticon-arrow-right-1" },
  { name: "Retours zone", path: "/return-zone-liste", icon: "flaticon-arrow-right-1" },
  { name: "Factures", path: "/invoices-liste", icon: "flaticon-bill" },
  { name: "Virements", path: "/virements-liste", icon: "flaticon-money" },
  { name: "Dépenses", path: "/spents", icon: "flaticon-money" },
  { name: "Produits stock", path: "/products-list", icon: "flaticon-parcel" },
  { name: "Colis stock", path: "/colis-stock-list", icon: "flaticon-sterile-box" },
  { name: "Vérifications", path: "/verifications", icon: "flaticon-check" },
  { name: "Paramètres compte", path: "/account-settings", icon: "flaticon-setting" },
  { name: "Zones", path: "/zones-settings", icon: "flaticon-map" },
  { name: "Villes", path: "/cities-settings", icon: "flaticon-map" },
  { name: "Agences", path: "/agencies-settings", icon: "flaticon-home" },
  { name: "Statuts", path: "/settings-statuts", icon: "flaticon-setting" },
  { name: "Types clients", path: "/settings-type-clients", icon: "flaticon-setting" },
  { name: "Banques", path: "/settings-banks", icon: "flaticon-setting" },
  { name: "Transports", path: "/settings-transports", icon: "flaticon-setting" },
  { name: "Mon profil", path: "/profile", icon: "flaticon-user-2" },
  { name: "Demandes RIB", path: "/rib-requests-list", icon: "flaticon-draft" },
  { name: "Demandes téléphone", path: "/phone-requests-list", icon: "flaticon-draft" },
  { name: "Black liste", path: "/black-list", icon: "flaticon-setting" },

];

export default defineComponent({
  name: "MainHeader",
  components: {
    LightDarkSwtichBtn,
  },
  setup() {
    const stateStoreInstance = stateStore;
    const isSticky = ref(false);
    const auth = useAuthStore();
    const user = auth.user;
    const router = useRouter();

    // Search
    const searchQuery = ref("");
    const searchOpen = ref(false);
    const highlightIndex = ref(0);
    const searchBoxRef = ref<HTMLElement | null>(null);

    const filteredPages = computed(() => {
      const q = searchQuery.value.trim().toLowerCase();
      if (!q) return [];
      return ALL_PAGES.filter((p) => p.name.toLowerCase().includes(q)).slice(0, 8);
    });

    function navigateTo(path: string) {
      router.push(path);
      closeSearch();
    }

    function goToFirst() {
      if (filteredPages.value.length) {
        navigateTo(filteredPages.value[highlightIndex.value]?.path ?? filteredPages.value[0].path);
      }
    }

    function closeSearch() {
      searchOpen.value = false;
      searchQuery.value = "";
      highlightIndex.value = 0;
    }

    function highlightNext() {
      if (highlightIndex.value < filteredPages.value.length - 1) highlightIndex.value++;
    }

    function highlightPrev() {
      if (highlightIndex.value > 0) highlightIndex.value--;
    }

    function handleClickOutside(e: MouseEvent) {
      if (searchBoxRef.value && !searchBoxRef.value.contains(e.target as Node)) {
        searchOpen.value = false;
      }
    }

    onMounted(() => {
      window.addEventListener("scroll", () => {
        isSticky.value = window.scrollY >= 100;
      });
      document.addEventListener("click", handleClickOutside);
    });

    onUnmounted(() => {
      document.removeEventListener("click", handleClickOutside);
    });

    function handleLogout() {
      auth.clearAuth();
      localStorage.clear();
      window.location.href = "/login";
    }

    return {
      isSticky,
      stateStoreInstance,
      user,
      handleLogout,
      searchQuery,
      searchOpen,
      searchBoxRef,
      filteredPages,
      highlightIndex,
      navigateTo,
      goToFirst,
      closeSearch,
      highlightNext,
      highlightPrev,
    };
  },
});
</script>

<style scoped>
.search-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  z-index: 9999;
  overflow: hidden;
}

.search-result-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: #333;
  transition: background 0.12s;
}
.search-result-item:hover,
.search-result-item--active {
  background: #f0f4ff;
  color: #0d6efd;
}
.search-result-icon {
  font-size: 15px;
  color: #6c757d;
  width: 18px;
  text-align: center;
  flex-shrink: 0;
}
.search-result-item:hover .search-result-icon,
.search-result-item--active .search-result-icon {
  color: #0d6efd;
}

.search-no-result {
  padding: 12px 14px;
  font-size: 13px;
  color: #6c757d;
  text-align: center;
}
</style>